import {Component, HostBinding, HostListener, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AbstractText} from '../abstract-text';
import {Subscription, timer} from 'rxjs';

@Component({
    selector: 'vui-refresh-text',
    templateUrl: './refresh-text.component.html',
    styleUrls: ['./refresh-text.component.scss']
})
export class RefreshTextComponent extends AbstractText implements OnChanges {
    @HostBinding('class.refreshing') public refreshing: boolean;
    @Input() public suffix: string;
    @Input() public value: string;

    ngOnChanges(simpleChanges: SimpleChanges) {
        this.refreshing = false;
    }

    /**
     * Start a timer on click. If there is no value change
     * returned, end the refresh period and end the refreshing status
     * manually
     */
    @HostListener('click')
    public refresh(): void {
        this.refreshing = true;
        const _timer$: Subscription = timer(3000).subscribe(() => {
            this.refreshing = false;
            _timer$.unsubscribe();
        });
    }
}
